import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {FindBySlug} from "@hooks/FindTranslate"
import Truncate from "@hooks/Truncate"
import {FormatBlogPostData} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKey"
import {
	BlogPostModuleType,
	MetaModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import BlogPosts from "@jsons/blogPosts.json"
import Post from "@pages/Blog/Post/Post"
import Error from "next/error"
import React from "react"

type Props = {
	locale: string
	article: string
	result: BlogPostModuleType
}

const PostPage = (props: Props) => {
	// Trow 404 page for unExist pages
	// ! Required for avoiding errors on server side rendering
	if (!props.result) {
		return <Error statusCode={404} />
	}

	// const {changeMetaData} = useContext(MetaDataContext)
	function removeHTMLFromString(input: string): string {
		// Regular expression to match HTML tags and their contents
		const regex = /<[^>]+>/g
		return input.replace(regex, "")
	}

	const description = Truncate(removeHTMLFromString(props.result.content), 60)

	const metadata: MetaModuleType = {
		title: props.result.title,
		description: description || "",
		keywords: "",
		author: "Dream Broker",
		ogTitle: props.result.title,
		ogType: "article",
		ogDescription: description || "",
		ogImage: props.result.thumbui.src
			? props.result.thumbui.src
			: "/DB.jpg",
	}

	// useEffect(() => {
	// 	changeMetaData(metadata)
	// }, [locale])

	return (
		<ContainerWrapper style={{overflow: "hidden"}}>
			<HeadMeta meta={metadata} />

			{/* Blog Post preview Element */}
			<Post
				data={{
					locale: props.locale,
					article: props.article,
					post: props.result,
				}}
			/>
		</ContainerWrapper>
	)
}

/**
 * Create Static Link paths list for creating Static Pages
 * ! Required for avoiding errors on server side rendering
 */
export const getStaticPaths = async ({locales}: {locales: any}) => {
	// Creating empty paths array
	const paths: any[] = []

	// Taking Data from Blog Posts JSON
	BlogPosts.entries.forEach((block) => {
		// Creating loop for creating paths for all Locales
		// ! Required for avoiding errors on server side rendering
		for (const locale of locales) {
			paths.push({
				params: {
					post: block.slug,
				},
				locale,
			})
		}
	})

	return {
		paths,
		fallback: false,
	}
}

/**
 * Create Static Props for preMade Links Paths to create a static Pages
 * ! Required for avoiding errors on server side rendering
 */
export const getStaticProps = async (context: {
	params: {post: string}
	locale: string
}) => {
	// Defining blog and locale const
	const article = context.params.post
	const locale = context.locale

	// Find right Blog Post Data from Blog Posts json by Slug
	const translated = FindBySlug(
		BlogPosts.entries,
		context.locale,
		context.params.post,
	)

	// Formate Single Blog Post data for Single Blog Post Page
	const result = FormatBlogPostData(translated)

	return {
		props: {article, locale, result},
	}
}

export default PostPage
